export const currentEnv: string = "prod";

const env: string = currentEnv;

export const Env = env;

const API_DEV_URL = "https://api.recette.dev.easymarket.sn";
const API_DEMO_URL = "https://api.recette.dev.easymarket.sn";
const API_PROD_URL = "https://api.recette.dev.easymarket.sn";

const VENDEUR_APIKEY_DEMO ="5e0631edc423e589281dda59035904aa330c79a444f6fefc1baf5a1ba42dd57d";
const VENDEUR_APIKEY_PROD ="5e0631edc423e589281dda59035904aa330c79a444f6fefc1baf5a1ba42dd57d";

export const APP_URL_DEV = "https://recette.dev.easymarket.sn/";
export const APP_URL_DEMO = "https://recette.dev.easymarket.sn/";
export const APP_URL_PROD = "https://recette.dev.easymarket.sn/";

function processApiUrl() {
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL; 
}

function processAppUrl() {
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey() {
  if (env === "prod") return VENDEUR_APIKEY_PROD;
  if (env === "demo") return VENDEUR_APIKEY_DEMO;
  return VENDEUR_APIKEY_DEMO;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyD0klc1PQS8QK--Be3rF3i8kW_idy04AVQ";

export const IntechApikey = "554ACA96-F050-442D-8E29-BEE77FAE821A";

export const GoogleClientId ="701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";